import { render } from "./StatsCard.vue?vue&type=template&id=60a6d8d6"
import script from "./StatsCard.vue?vue&type=script&lang=js"
export * from "./StatsCard.vue?vue&type=script&lang=js"

import "./StatsCard.vue?vue&type=style&index=0&id=60a6d8d6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__